
import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({ name: 'ArticleBlock' })
export default class ArticleBlock extends Vue {
	@Prop({ required: true }) content: string | null;
}
